import { _, helpers, React, ts, ui } from '_core';

import { transform } from './helpers';
import { Params } from './types';
import { nestedBarChartFormat } from '../../common/formatters/nested-bar-chart';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  portfolios: string;
  fullScreen: boolean;
  hasBenchmark: boolean;
  params: Params;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  title: string;
};

const Chart = ({
  id,
  readOnly,
  loadWidgetData,
  portfolios,
  params,
  fullScreen,
  hasBenchmark = false,
  title,
}: ChartProps) => {
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file: portfolios,
        },
      });
      if (response) {
        response.data.forEach((row) => {
          delete row.as_of;
        });

        setData(response.data);
      }
    } catch (err) {
      setError(JSON.stringify(err));
    }
  };

  React.useEffect(() => {
    if (portfolios) loadData();
    return () => setData(null);
  }, [portfolios]);

  const formattedData = React.useMemo(() => {
    if (_.isNil(data)) return null;
    return transform(
      nestedBarChartFormat(data),
      params.statistics_type,
      params.isBasket,
      hasBenchmark,
      params.benchmark?.type === 'INDEX',
      params.showTargetWeight
    );
  }, [data]);

  return (
    <ui.NestedBarChart
      id={id}
      data={formattedData?.data}
      count={formattedData?.count}
      category="category"
      numberFormat={params.statistics_type !== 'adjusted' ? '#.##%' : '#.##'}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      fullScreen={fullScreen}
      exportTitle={title}
      readOnly={readOnly}
    />
  );
};

export default Chart;
